import { useEffect } from "react";
import { useScript } from "react-recipes";

import { jjLogger, newRelic } from "utils/logUtils";
import useSettings from "hooks/useSettings";

const useRecaptcha = () => {
  const {
    settings: {
      recaptcha: { enabled: recaptchaEnabled, key: recaptchaKey },
    },
  } = useSettings();

  const [recaptchaLoaded, recaptchaLoadError] = useScript(
    `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
  );

  useEffect(() => {
    if (recaptchaEnabled && recaptchaLoaded && recaptchaLoadError) {
      const error = "useRecaptcha.js: Error loading recaptcha script";

      newRelic(error);
      jjLogger.log(error);
    }
  }, [recaptchaLoaded, recaptchaLoadError]);

  const recaptcha = (settings) =>
    new Promise((resolve) => {
      if (!recaptchaEnabled) return resolve();

      return window.grecaptcha.ready(() => {
        window.grecaptcha.execute(recaptchaKey, settings).then((recaptchaToken) => {
          resolve(recaptchaToken);
        });
      });
    });

  return {
    recaptcha,
  };
};

export default useRecaptcha;
